export default __webpack_public_path__ + "static/mit-24e7bea3583d9e95d5a87f4f403c4dee.svg";